import React, { PureComponent, Fragment } from 'react';
import { cloneDeep, find, get, isFunction } from 'lodash';
import { language } from '../../../language';
import { ProductSelector, TopicSelector, CustomUrlSelector, HotSelector } from '../link-selector';
import { LinkTypeSelector } from './link-type-selector';
import { LinkTypeMode } from '../../../types';
import './index.less';
import { Button, Input } from 'antd';
/**
 * 可视化-配置链接类型
 */
export class LinkType extends PureComponent<{
    selector?: {
        singleProduct: {
            contentConfig: Record<string, any>;
            modalConfig: Record<string, any>;
            render: (props: {
                onChange: (value: any) => void;
                value: any;
            }) => JSX.Element | undefined;
        };
        topic: {
            contentConfig: Record<string, any>;
            modalConfig: Record<string, any>;
            render: (props: {
                onChange: (value: any) => void;
                value: any;
            }) => JSX.Element | undefined;
        };
        customUrl: {
            modalConfig: Record<string, any>;
            render: (props: {
                onChange: (value: any) => void;
                value: any;
            }) => JSX.Element | undefined;
        };
        [linkType: string]: { render: (props: any) => JSX.Element };
    };
    onChange: (value: any) => void;
    value: {
        describe?: string;
        linkType: string;
        linkParams: any;
        pic?: string | undefined;
        uuid?: any;
    };
    linkTypes: Array<{ id: string; name: string }>;
    linkTypeMode?: LinkTypeMode;
    showDescribe?: boolean;
    disabled?: boolean;
}> {
    static defaultProps = {
        selector: {
            singleProduct: { contentConfig: {}, modalConfig: {} },
            topic: { contentConfig: {}, modalConfig: {} },
            customUrl: { contentConfig: {}, modalConfig: {} },
        },
    };

    changeDescribe = (e: any) => {
        const { onChange, value } = this.props;
        let newValue = cloneDeep(value);
        newValue.describe = e.target.value || '';
        onChange(newValue);
    };

    changeType = (type: string) => {
        const { onChange, value } = this.props;
        let newValue = cloneDeep(value);
        newValue.linkType = type;
        newValue.linkParams = null;
        onChange(newValue);
    };

    changeTarget = (linkParams: any) => {
        const { value, onChange } = this.props;
        let newValue = cloneDeep(value);
        newValue.linkParams = linkParams;
        onChange(newValue);
    };

    getLinkTypeName = () => {
        const {
            value: { linkType },
            linkTypes,
        } = this.props;

        let objType = find(linkTypes, { id: linkType });
        return objType ? objType.name : '';
    };

    renderLinkTarget = () => {
        const { selector, value } = this.props;
        const { linkType, linkParams, pic, uuid } = value;
        const selectorProps = {
            value: { linkType, linkParams, pic: pic || '' },
            onChange: this.changeTarget,
        };
        switch (linkType) {
            case 'product':
                const customRenderProduct = get(selector, 'singleProduct.render');
                return isFunction(customRenderProduct) ? (
                    customRenderProduct(selectorProps)
                ) : (
                    <ProductSelector
                        {...selectorProps}
                        type={'Single'}
                        contentConfig={get(selector, 'singleProduct.contentConfig')}
                        modalConfig={get(selector, 'singleProduct.modalConfig')}
                    />
                );
            case 'topic':
                const customRenderTopic = get(selector, 'topic.render');
                return isFunction(customRenderTopic) ? (
                    customRenderTopic(selectorProps)
                ) : (
                    <TopicSelector
                        {...selectorProps}
                        contentConfig={get(selector, 'topic.contentConfig')}
                        modalConfig={get(selector, 'topic.modalConfig')}
                    />
                );
            case 'link':
                const customRenderCustomUrl = get(selector, 'customUrl.render');
                return isFunction(customRenderCustomUrl) ? (
                    customRenderCustomUrl(selectorProps)
                ) : (
                    <CustomUrlSelector
                        {...selectorProps}
                        modalConfig={get(selector, 'customUrl.modalConfig')}
                    />
                );
            case 'hotZone':
                return (
                    <HotSelector
                        {...selectorProps}
                        uuid={uuid}
                        type={'Single'}
                        contentConfig={get(selector, 'singleProduct.contentConfig')}
                        modalConfig={get(selector, 'singleProduct.modalConfig')}
                    />
                );
            default:
                const customRender = get(selector[linkType], 'render');
                return isFunction(customRender) ? (
                    customRender(selectorProps)
                ) : (
                    <span>{this.getLinkTypeName()}</span>
                );
        }
    };

    render() {
        const { value, linkTypes, linkTypeMode, showDescribe, disabled } = this.props;
        const { linkType } = value;
        return (
            <Fragment>
                {showDescribe && (
                    <div className="link-item-field describeStyle">
                        <label className="field-name">文本描述：</label>
                        <Input
                            placeholder="输入内容"
                            value={value.describe || ''}
                            onChange={this.changeDescribe}
                        />
                    </div>
                )}
                <div className="link-item-field">
                    <label className="field-name">
                        {language.getText('components.Tools.linkType')}：
                    </label>
                    <LinkTypeSelector
                        value={value}
                        linkTypes={linkTypes}
                        linkTypeMode={linkTypeMode}
                        onChange={this.changeType}
                        disabled={!!disabled}
                    />
                </div>
                <div className="link-item-field" style={{ marginTop: 16 }}>
                    <label className="field-name">
                        {linkType === 'hotZone'
                            ? '编辑热区'
                            : language.getText('components.Tools.linkTarget')}
                        ：
                    </label>
                    {this.renderLinkTarget()}
                </div>
            </Fragment>
        );
    }
}
